import { Theme } from '@emotion/react';
import { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme, type SxProps } from '@mui/material/styles';

interface SectionHeaderProps {
  children: ReactNode;
  color?: string;
  iconSize?: number;
  sx?: SxProps<Theme>;
  description?: string | ReactNode;
}

export const SectionHeader = ({
  children,
  color,
  iconSize = 8,
  sx,
  description,
}: SectionHeaderProps) => {
  const theme = useTheme();

  return (
    <Stack direction="column" gap={1} sx={{ ...sx, width: '85%' }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ width: '100%' }}
      >
        <Box
          sx={{
            width: iconSize,
            height: iconSize,
            bgcolor: color || theme.palette.primary.main,
            borderRadius: '50%',
          }}
        />
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          {children}
        </Typography>
      </Stack>
      {description && <Typography variant="caption">{description}</Typography>}
    </Stack>
  );
};
